import { Button, Fieldset } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormHelpers } from '../../screens/utils';
import { uiStateSelectors } from '../../services/redux/features/uiState.slice';

export const FormSectionEditButton = ({ onClick, formHelpers }: { onClick: () => void; formHelpers: FormHelpers }) => {
  const { summaryMode } = formHelpers;
  const isAnySectionInEditMode = useSelector(uiStateSelectors.isAnySectionInEditMode);

  if (!summaryMode || isAnySectionInEditMode) return null;

  return (
    <Fieldset.Row className="u-text-right u-pt-none">
      <Button type="button" icon="semantic-edit" onClick={onClick} />
    </Fieldset.Row>
  );
};
